import $ from 'jquery';
import { LatLngBounds } from 'leaflet/src/geo/LatLngBounds';
import { Rectangle } from 'leaflet/src/layer/vector/Rectangle';
import { Popup } from 'leaflet/src/layer/Popup';
import * as i18n from 'i18n-setup';
import * as Overlay from 'overlay';
import * as Doc from 'doc';
import style from 'style';
import state from 'state';

var supportLocation = 'geolocation' in navigator,
    currentLocation = null;

function parseHTML(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.children[0];
}

function gmapsIMG(loc, x, y) {
    return 'http://maps.googleapis.com/maps/api/staticmap?center=' + loc + '&zoom=10&size=' + x + 'x' + y + '&sensor=false';
}

function wantLocation() {
    function update() {
        if (currentLocation)
            $('.geoloc').text(currentLocation).append('<img src="' + gmapsIMG(currentLocation, 225, 150) + '" width=150 height=100>');
        else
            $('.geoloc').text(i18n.str('sig.geoloc.na'));
    }
    function precision(meters) {
        // http://en.wikipedia.org/wiki/Decimal_degrees#Precision
        if (meters > 200000) return 0;
        if (meters > 20000) return 1;
        if (meters > 2000) return 2;
        if (meters > 200) return 3;
        return 4; // 11.1 meters precision is a good minimum
    }
    function ok(pos) {
        var decimals = precision(pos.coords.accuracy);
        currentLocation = pos.coords.latitude.toFixed(decimals) + ',' + pos.coords.longitude.toFixed(decimals);
        update();
    }
    function error(/*err*/) {
        currentLocation = null;
        update();
    }
    if (currentLocation !== null || !supportLocation) {
        update();
        return;
    }
    var opts = {
        enableHighAccuracy: false, // it's ok to use triangulation (TODO?)
        timeout: 5000,             // 5" timeout
        maximumAge: 300000         // 5' old data is ok
    };
    navigator.geolocation.getCurrentPosition(ok, error, opts);
}

function html(str) { //TODO: remove
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function addElem(td, val) {
    if (typeof val === 'string')
        val = document.createTextNode(val);
    td.appendChild(val);
}

function addRow(table /*, ...*/) {
    var tr = document.createElement('tr');
    for (var i = 1; i < arguments.length; ++i) {
        var td = document.createElement('td'),
            elem = arguments[i];
        if (elem !== null) {
            if ($.isArray(elem)) {
                for (var j = 0; j < elem.length; ++j)
                    addElem(td, elem[j]);
            } else
                addElem(td, elem);
        }
        tr.appendChild(td);
    }
    table.appendChild(tr);
}

function addImg(name) {
    var i = document.createElement('img');
    i.src = 'images/' + name;
    return i;
}

function showSigInfo(name) {
    if (!(name in state.sigInfo))
        throw new Error('Signature “' + name + '” has not been verified.');
    var s = state.sigInfo[name],
        t = document.createElement('table'),
        type = s.type;
    t.className = 'sigInfo ' + (s.validSignature ? 'sigOK' : 'sigNO');
    if (s.isGraphometric)
        type = [ type, ' ', i18n.span('info.grapho') ];
    else if (s.isSimple)
        type = [ type, ' ', i18n.span('info.simple') ];
    addRow(t, i18n.span('info.type'), type);
    addRow(t, i18n.span('info.subject'), s.certificate.subject.replace(/\\?, */g, ', '));
    addRow(t, i18n.span('info.issuer'), s.certificate.issuer.replace(/\\?, */g, ', '));
    if (s.signingTime || s.timestamp)
        addRow(t,
            [i18n.span('info.time'), s.timestamp ? i18n.span('info.verified'): i18n.span('info.local')],
            [addImg(s.timestamp ? 'timeGreen.png' : 'timeGray.png'), new Date(s.signingTime).toISOString()]);
    if (s.contact) {
        if (s.contactVerified) {
            var contact = document.createElement('span');
            contact.innerHTML = s.contact.replace(s.contactVerified, '<span class="verified">' + s.contactVerified + '</span>');
            addRow(t, i18n.span('info.contact'), contact);
        } else
            addRow(t, i18n.span('info.contact'), s.contact);
    }
    if (s.reason)
        addRow(t, i18n.span('info.reason'), s.reason);
    if (s.location) {
        var loc = s.location;
        if (/^-?[0-9]+([.][0-9]*)?,-?[0-9]+([.][0-9]*)?$/.test(loc)) {
            var a = document.createElement('a'),
                i = document.createElement('img');
            i.src = gmapsIMG(loc, 225, 150);
            i.style.width = '225px';
            i.style.height = '150px';
            a.href = 'https://maps.google.com/maps?q=' + loc;
            a.target = '_blank';
            a.appendChild(document.createTextNode(loc));
            a.appendChild(document.createElement('br'));
            a.appendChild(i);
            loc = a;
        }
        addRow(t, i18n.span('info.location'), loc);
    }
    return t;
}

function showSigCreate(name, opt, pos) {
    var h = state.pdf.triggerSafe('showSigCreate', [ name, opt, pos ]);
    if (h) return h; // if a registered handler produced something, use that
    if (opt.readonly)
        return '<p>' + html(i18n.str('sig.field')) + ' <b>' + html(name) + '</b></p>';
    var grapho = (typeof opt.graphometric === 'string'),
        simple = (typeof opt.simple === 'string') && !grapho,
        type = (opt.userChoice || (!grapho && !simple)) ? 'd' : 'g',
        s = '<form action="#" method=POST autocomplete=off class="sig-form sig-' + type + '">';
    s += i18n.str(name ? 'sig.visible' : 'sig.invisible');
    s += '<input style="display:none"><input type="password" style="display:none">'; // to avoid Chrome auto-completion
    s += '<table>';
    s += '<tr><td>' + html(i18n.str('sig.type')) + '</td><td>';
    if (opt.userChoice) {
        s += '<select name=type>' +
            '<option value=d>' + html(i18n.str('sig.type.digital')) + '</option>' +
            '<option value=g>' + html(i18n.str('sig.type.grapho')) + '</option>' +
            '<option value=s>' + html(i18n.str('sig.type.simple')) + '</option>' +
            '</select>';
    } else if (grapho) {
        s += '<input type=hidden name=type value=g>';
        s += html(i18n.str('sig.type.grapho'));
    } else if (simple) {
        s += '<input type=hidden name=type value=s>';
        s += html(i18n.str('sig.type.simple'));
    } else {
        s += '<input type=hidden name=type value=d>';
        s += html(i18n.str('sig.type.digital'));
    }
    s += '</td></tr>';
    if (opt.userChoice || grapho || simple)
        s += '<tr class="sig-g sig-s"><td>' + html(i18n.str('sig.name')) + '</td><td><input type=text name=cn value="' + html(opt.graphometric || opt.simple || '') + '"></td></tr>';
    if (opt.userChoice || (!grapho && !simple)) {
        if (opt.hsm === null) {
            s += '<tr class="sig-d"><td>' + html(i18n.str('sig.hsm')) + '</td><td><select name="hsm">';
            for (var k in state.hsm)
                s += '<option value="' + html(k) + '">' + html(state.hsm[k]) + '</option>';
            s += '</select></td></tr>';
        }
        s += '<tr class="sig-d"><td>' + html(i18n.str('sig.username')) + '</td><td>' + (opt.alias ? opt.alias : '<input type=text name=alias>') + '</td></tr>';
        if (!opt.pin) {
            var timeout = state.info.timestamp/1000 + opt.keyTimeout - 1 /*RTT*/;
            s += '<tr class="sig-d"><td>' + html(i18n.str('sig.password')) + '</td><td>';
            if (opt.keyTimeout) s += '<span class="keyCached" data-timeout="' + timeout + '">';
            s += '<input type=password name=pin autocomplete=off>';
            if (opt.keyTimeout) s += '<span>' + i18n.str('sig.keyCached') + '</span></span>';
            s += '</td></tr>';
        }
    }
    if (state.canvas && (name || grapho || simple) && !opt.image) {
        s += '<tr><td></td><td><input type=hidden name=sig value="">';
        //jshint eqnull: true
        if (opt.tablet == null)
            s += '<label class="sig-d sig-s"><input type=checkbox name=usesig> ' + html(i18n.str('sig.graphical')) + '</label>';
        else
            s += '<input type=hidden name=usesig value="' + html(opt.tablet) + '">';
        s += '</td></tr>';
    }
    if (supportLocation && opt.geoloc === true) {
        s += '<tr><td></td><td>';
        s += '<label><input type=checkbox name=geoloc> ' + html(i18n.str('sig.geoloc.want')) + '</label>';
        s += '<input type=hidden name=location><div class="geoloc">' + html(i18n.str('sig.geoloc.na')) + '</div>';
        s += '</td></tr>';
    }
    if (opt.sms) {
        s += '<tr><td>SMS:</td><td>';
        s += html(i18n.str('sig.sms'));
        s += '<br/>';
        if (opt.sms === true)
            s += '<input type=text name=sms value="+39">';
        else
            s += '<tt>' + opt.sms + '</tt>';
        s += '</td></tr>';
    }
    s += '<tr><td colspan=2><input type=submit name=subbut value="' + html(i18n.str('sig.signButton')) + '"></td></tr>';
    s += '</table>';
    if (name)
        s += '<input type=hidden name=field value="' + html(name) + '">';
    if (opt.java === true)
        s += '<input type=hidden name=java value=1>';
    if (pos) {
        s += '<input type=hidden name=page value="' + state.page + '">';
        s += '<input type=hidden name=coords value="' + pos.toBBoxString() + '">';
    }
    s += '<div class="spinner"></div>';
    s += '</form>';
    // activate the static code
    var f = $(s);
    f.submit(function (e) {
        e.preventDefault();
        sign(f[0]);
    });
    f.find('select[name="type"]').change(function () {
        f[0].className = 'sig-form sig-' + this.value;
    });
    f.find('input[name="geoloc"]').change(function () {
        if (this.checked) wantLocation();
    });
    return f[0];
}

function signEnable(form, enabled) {
    form.subbut.disabled = !enabled;
    if (enabled)
        $(form).removeClass('sig-busy');
    else
        form.className += ' sig-busy';
}

function signRaw(form) {
    signEnable(form, false);
    state.pdf.triggerSafe('signing', [ form ]);
    $.postJSON(state.base + 'sign', $(form).serialize()
    ).then(function (data) {
        //TODO: use Prime-like method to set callback
        if ('error' in data) {
            Overlay.error(i18n.str('sig.error') + '\n' + (i18n.str('error.' + data.error, data.error)));
            return;
        }
        if ('challenge' in data) {
            var c = $('<div/>'),
                myf = $('<form autocomplete=off/>'),
                txt = $('<input type="password"/>'),
                ok = $('<input type="submit"/>');
            c.append($('<h1/>').i18n('sig.challenge'));
            c.append($('<div class=challenge/>').text(i18n.str('challenge.' + data.challenge, data.challenge)));
            c.append($('<br/>'));
            c.append(myf.append(txt).append(ok));
            myf.submit(function (e) {
                e.preventDefault();
                if (!('pin' in form))
                    $('<input type="hidden" name="pin"/>').appendTo(form);
                form.pin.value = txt.val();
                document.getElementById('overlay').className = '';
                signRaw(form);
                return false;
            });
            Overlay.error(c);
            return;
        }
        state.pdf.triggerSafe('signed', [ data ]);
        state.map.closePopup();
        Doc.updateFiles(data);
    }).catch(function () {
        Overlay.error(i18n.str('err.contact'));
    }).always(function () {
        if (form.pin) form.pin.value = '';
        if (form.sig) form.sig.value = '';
        signEnable(form, true);
    });
}

export function sign(form, fromCanvas) {
    signEnable(form, false);
    try {
        if (form.geoloc && (form.geoloc.checked || form.geoloc.value === 'yes') && currentLocation !== null)
            form.location.value = currentLocation;
        if (!form.sig)
            ; // no signature field present
        else if (!(form.type.value === 'g' || form.usesig.checked || form.usesig.value === 'yes' || form.usesig.value === 'true'))
            form.sig.value = '';
        else if (fromCanvas)
            form.sig.value = state.canvas.generateXML();
        else if (form.sig.value === '') {
            try {
                state.canvas.get((form.java && form.java.value === '1'), (form.field && form.field.value), function (status) {
                    if (status)
                        sign(form, true);
                    else
                        state.map.closePopup();
                });
            } catch (e) {
                // return;
            }
            return;
        }
    } catch (e) {
        return;
    }
    signRaw(form);
}

function addField(empty) {
    var cont = $('#sigNew'),             // this is the whole screen (grayed out)
        div1 = $('#sigNew > div'),       // this is the visible page area
        div2 = $('#sigNew > div > div'), // this is the actual signature area
        form = $('#sigNew form')[0],
        ok = $('#sigNewOK'),
        cancel = $('#sigNewCancel'),
        buttons = ok.add(cancel),
        px2mm = Math.pow(2, -state.map.getZoom()), //TODO: this code is duplicate
        px2cm = px2mm / 10,
        force = function (value, min, max) {
            return (value < min) ? min : (value > max) ? max : value;
        },
        cleanup = function () {
            cont.off().hide();
            div2.attr('style', ''); // remove any style added by draggable/resizable
            buttons.off('click touchstart dragstart');
        },
        updateCoords = function () {
            var p = div2.position(); // doesn't show up until it's defined in local CSS
            form.x.value = (px2cm * p.left).toFixed(1);
            form.y.value = (px2cm * p.top).toFixed(1);
            form.w.value = (px2cm * div2.outerWidth()).toFixed(1);
            form.h.value = (px2cm * div2.outerHeight()).toFixed(1);
        },
        page0 = state.info.pagesize[state.page],
        page1 = state.map.latLngToContainerPoint([ 0, 0 ]),
        page2 = state.map.latLngToContainerPoint([ page0.h, page0.w ]),
        contW = cont.width(),
        contH = cont.height(),
        aspectRatio = false;
    // the bounding box for the signature is the visible part of the page
    page1.x = force(page1.x, 0, contW);
    page1.y = force(page1.y, 0, contH);
    page2.x = force(page2.x, 0, contW);
    page2.y = force(page2.y, 0, contH);
    div1.css({
        left:   page1.x + 'px',
        top:    page1.y + 'px',
        width:  (page2.x - page1.x) + 'px',
        height: (page2.y - page1.y) + 'px'
    });
    // set up image
    if (typeof state.info.fields.add.image == 'object') {
        var img = state.info.fields.add.image, // url, width, height
            url = (img.url.startsWith('data:')) ? img.url : state.base + 'extra/' + img.url;
        //TODO avoid img.width, use create instead
        div2.css({
            'background':        'url(' + url + ')',
            'background-size':   '100% 100%',
            'background-repeat': 'no-repeat',
            'width':             (img.width  / px2mm - 2) + 'px',
            'height':            (img.height / px2mm - 2) + 'px'
        });
        aspectRatio = true; //TODO: check
    }
    // let the user drag and resize the area inside the bounding box
    div2.draggable({
        containment: 'parent', //TODO: sometimes it doesn't clip properly
        drag:  updateCoords
    }).resizable({
        containment: 'parent',
        handles:     'n, ne, e, se, s, sw, w, nw',
        aspectRatio: aspectRatio,
        resize:      updateCoords
    });
    updateCoords();
    // set up button logic
    cancel.on('click touchstart dragstart', cleanup);
    ok.on('click touchstart dragstart', function () {
        var p0 = div2.offset(), // assuming the map is full-screen
            p1 = [ p0.left, p0.top ],
            p2 = [ p0.left + div2.outerWidth(), p0.top + div2.outerHeight() ],
            c1 = state.map.containerPointToLatLng(p1),
            c2 = state.map.containerPointToLatLng(p2),
            pos = new LatLngBounds(c1, c2),
            rect = new Rectangle(pos, style.empty),
            opt = Doc.popupOpts();
        cleanup();
        Doc.layer.sigs.addLayer(rect.bindPopup(
            empty ? showEmptySig(pos) : showSigCreate('*add', state.info.fields.add, pos), opt));
        rect.openPopup(pos.getCenter());
        state.pdf.triggerSafe('newField', [ pos, empty ? 'empty' : 'create' ]);
    });
    // finally show it
    cont.show();
}

function showField(name) {
    var pos = false,
        opt = Doc.popupOpts(),
        setPos = function (s) {
            if (s && (s.position[0] !== -1)) {
                Doc.changePage(s.position[0]);
                pos = Doc.convertPos(s.position).getCenter();
            } else
                opt.withTip = false; // invisible signature, hide the tip
        },
        popup;
    state.panel.sign.close();
    if (name === '*inv')
        popup = showSigCreate(null, state.info.fields.invisible);
    else if (name === '*add')
        return addField(true);
    else if (name === '*addSign')
        return addField(false);
    else {
        if (state.info.fields.empty[name]) {
            setPos(state.info.fields.empty[name]);
            popup = showSigCreate(name, state.info.fields.empty[name]);
        } else {
            setPos(state.info.fields.signed[name]);
            popup = showSigInfo(name);
        }
    }
    state.map.openPopup(new Popup(opt).setLatLng(pos || state.map.getCenter()).setContent(popup));
}

function showEmptySig(pos) {
    var h = state.pdf.triggerSafe('showEmptySig', [ state.info.fields.add, pos ]);
    if (h) return h; // if a registered handler produced something, use that
    var form = $('<form action="#" method=POST autocomplete=off />');
    form.append('<input type=hidden name=page value="' + state.page + '">');
    form.append('<input type=hidden name=coords value="' + pos.toBBoxString() + '">');
    $('<div/>').i18n('add.new').appendTo(form);
    var label = $('<label/>').css({
        display: 'block',
        marginTop: '1em',
        marginBottom: '1em'
    }).appendTo(form);
    label.append(i18n.span('add.name'));
    $('<input type=text name=newField />').css({ marginLeft: '1em' }).appendTo(label);
    $('<input type=submit name=subbut />').i18n('add.createButton').appendTo(form);
    form.submit(function (e) {
        e.preventDefault();
        signRaw(form[0]);
    });
    return form[0];
}

function sigShortInfo(name, opt) {
    var s = state.sigInfo && state.sigInfo[name],
        o = $('<a/>').attr('href', '#' + name).click(function () { showField(name); return false; }),
        bullet = function (text, className) { return $('<span/>').addClass('bullet').addClass(className).i18n('bullet.' + text); };
    if (name === '*inv')
        o.append(i18n.span('add.inv')).prepend(bullet('empty', 'sigEmpty'));
    else if (name === '*add')
        o.append(i18n.span('add.fld')).prepend(bullet('empty', 'sigEmpty'));
    else if (name === '*addSign')
        o.append(i18n.span('add.sig')).prepend(bullet('empty', 'sigEmpty'));
    else if (s) {
        if (s.certificate && s.certificate.subjectShort)
            o.text(s.certificate.subjectShort);
        if (s.validSignature)
            o.prepend(bullet('ok', 'sigOK'));
        else
            o.prepend(bullet('no', 'sigNO'));
        //TODO: la prossima riga è in parte ridondante con le precedenti, forse era un modo per saperlo subito (o stilare diversamente), ma allora sarebbe carino gestire anche "sigEmpty"?
        o.addClass(s.validSignature ? 'sigOK' : 'sigNO');
    } else {
        var showName = (opt && opt.name) ? opt.name : name;
        o.append(i18n.span('add.empty')).append(' ' + showName).prepend(bullet('empty', 'sigEmpty'));
    }
    return o;
}

export function populateFields() {
    var ul = $('<ul/>'),
        fields = state.info.fields,
        name;
    $('#sigPanel > .content').empty().append($('<h3/>').i18n('add.sigs')).append(ul);
    if (state.sigInfo)
        for (name in state.sigInfo)
            $('<li/>').append(sigShortInfo(name)).appendTo(ul);
    else if (fields.verify)
        $('<li/>').i18n('add.ver').appendTo(ul);
    for (name in fields.empty)
        $('<li/>').append(sigShortInfo(name, fields.empty[name])).appendTo(ul);
    if (fields.invisible.enabled)
        $('<li/>').append(sigShortInfo('*inv')).appendTo(ul);
    if (fields.add.enabled) {
        if (fields.add.signed !== false)
            $('<li/>').append(sigShortInfo('*addSign')).appendTo(ul);
        if (fields.add.empty !== false)
            $('<li/>').append(sigShortInfo('*add')).appendTo(ul);
    }
    if (ul.is(':empty'))
        $('#sigPanel').hide();
    else if (state.feature.signature !== false)
        $('#sigPanel').show();
    state.pdf.triggerSafe('sigPanelUpdated');
}

export function managePopups(e) {
    var node = $('.keyCached', e.popup._contentNode);
    if (!node.length)
        return;
    var timeout = node.data('timeout') * 1000,
        cont = node.html();
    if (cont.indexOf('{timeout}') < 0)
        return;
    node.html(cont.replace('{timeout}', '<span class="time"></span>'));
    var value = $('.time', node),
        update = function () {
            var remaining = timeout - Date.now();
            if (remaining < 1000) {
                node.removeClass('keyCached');
                node.children('span').remove();
            } else {
                value.text(0|(remaining/1000));
                setTimeout(update, (remaining % 1000) + 50);
            }
        };
    update();
}

export function highlight() {
    function thenSign(html) {
        return function () {
            if (typeof html == 'function')
                html = html();
            if (typeof html == 'string')
                html = parseHTML(html);
            sign(html);
        };
    }
    var opt = Doc.popupOpts();
    Doc.layer.sigs.clearLayers();
    // prepare signature layer
    if (state.sigInfo)
        $.each(state.info.fields.signed, function (name, sig) {
            if (sig.position[0] == state.page)
                Doc.layer.sigs.addLayer(
                    new Rectangle(Doc.convertPos(sig.position), state.sigInfo[name].validSignature ? style.good : style.bad)
                        .bindPopup(showSigInfo(name), opt)
                );
        });
    $.each(state.info.fields.empty, function (name, sig) {
        if (sig.position[0] == state.page) {
            var rectStyle = state.pdf.triggerSafe('styleSigEmpty', [ name, sig ]) || style.empty,
                rect = new Rectangle(Doc.convertPos(sig.position), rectStyle),
                html = showSigCreate(name, sig);
            if (sig.directClick && (sig.graphometric || sig.simple))
                rect.on('click', thenSign(html));
            else // usual popup bubble
                rect.bindPopup(html, opt);
            Doc.layer.sigs.addLayer(rect);
        }
        if (sig.immediate && !sig.directClick) {
            // show it immediately, but only once, or reading the rest of the document becomes impossible
            sig.immediate = false;
            showField(name);
        }
    });
}
